import type { Bill } from '../entities/entityTypes';
import { useRefetchBillsMutationOptions } from '../entities/membership/hooks/useRefetchBillsMutationOptions';
import { requestBuilder } from '../http/RequestBuilder';

export interface UpsertBillBody {
    id?: string;
    membershipId: string;
    displayName: string;
    /** Whole cents (e.g. 5500 for $55.00). */
    amount: number;
    category: string;
    activationStatus: string;
    cadence: string;
    /** Omit on create when the server assigns an account (e.g. Money Mapper). */
    accountId?: string;
    payee: string;
    description?: string;
    /** Set on create (e.g. `MONEY_MAPPER` from Money Mapper, `MANUAL` elsewhere). */
    creationType?: string;
}

const useUpsertBill = requestBuilder.mutation<Bill, UpsertBillBody>({
    endpoint: '/api/admin/holistic/bill',
    method: 'POST',
});

export const useUpsertBillAndRefetch = (membershipId: string) => {
    const refetchBillsMutationOptions =
        useRefetchBillsMutationOptions(membershipId);

    const { mutateAsync } = useUpsertBill(refetchBillsMutationOptions);

    const upsertBillAsync = async (body: UpsertBillBody) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        upsertBillAsync,
    };
};
